import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/case-studies/skincare-transformation")({
  beforeLoad: () => {
    throw redirect({ to: "/", statusCode: 301 });
  },
});
